const model = {
    tourCount: {},
    loading: false,
    errors: null,
};

export default model;
